import { render, staticRenderFns } from "./UndertakingForm.vue?vue&type=template&id=01e7627e"
import script from "./UndertakingForm.vue?vue&type=script&lang=js"
export * from "./UndertakingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports